// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateTextElementColorReducer extends Reducer
{
	public static reducerName: string = "UpdateTextElementColor";
	public static call(_elementId: number, _color: string) {
		this.getReducer().call(_elementId, _color);
	}

	public call(_elementId: number, _color: string) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _colorType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_colorType, _color);
		this.client.call("UpdateTextElementColor", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let colorType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let colorValue = AlgebraicValue.deserialize(colorType, adapter.next())
		let color = colorValue.asString();
		return [elementId, color];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _color: string) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _color: string) => void)
	{
		this.client.on("reducer:UpdateTextElementColor", callback);
	}
}


export default UpdateTextElementColorReducer
